import React from "react";
import { SearchX } from "lucide-react";

export function EmptyState() {
  return (
    <div className="mt-12 flex flex-col items-center justify-center text-center">
      <div className="rounded-full bg-brand-surface p-3">
        <SearchX className="h-6 w-6 text-brand-text" />
      </div>
      <h3 className="mt-4 text-sm font-semibold text-brand-text">
        No results found
      </h3>
      <p className="mt-1 text-sm text-brand-muted">
        Try adjusting your search terms or explore different keywords
      </p>
    </div>
  );
}
